import { Message } from 'element-ui'
import axios from 'axios'
import router from '@/router'
import store from '@/store'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.interceptors.request.use(function (config) {
  config.headers.token = store.getters.getUser.token
  return config
}, function (err) {
  console.log(err)
})

axios.interceptors.response.use(function (res) {
  if (res.data.code === '1111') {
    Message({
      message: res.data.message,
      type: 'error'
    })
    store.dispatch('asyncUpdateUser', {
      token: ''
    })
    router.push('/login')
  }
  return res
}, function (err) {
  console.log(err)
  Message({
    message: '系统未知错误,请联系管理员',
    type: 'error'
  })
})

export default axios
